const DEFAULT_CHUNK_SIZE = 20;

// eslint-disable-next-line import/prefer-default-export
export function chunkArray<T>(
  items: T[],
  maxChunkSize: number = DEFAULT_CHUNK_SIZE,
): T[][] {
  if (items.length === 0) return [];
  const effectiveSize = items.length > 10
    ? Math.min(Math.ceil(items.length / 4), maxChunkSize)
    : maxChunkSize;

  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += effectiveSize) {
    chunks.push(items.slice(i, i + effectiveSize));
  }
  return chunks;
}
